import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            shipping_cost :'',
            shipping_cost_detail:'',
            deliveryKey:0,
        }
    },
    validators: {
        shipping_cost: function (value) {
            return Validator.value(value)
                .required('배송비 상세설정을 입력해주세요.')
        },
        shipping_cost_detail: function (value) {
            return Validator.value(value)
                .required('기본 배송비를 입력해주세요.')
        },
        deliveryKey :function (value) {
            return Validator.value(value)
                .required('키가 없습니다.')
        },
    },
}
